var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 40 } },
        [
          _c("el-col", { attrs: { lg: 8, md: 8, sm: 24 } }, [
            _c("h1", { staticClass: "title" }, [_vm._v("Informações")]),
            _c("div", { staticClass: "menu" }, [
              _vm.EXIBIR_OBSERVACOES
                ? _c(
                    "div",
                    { staticClass: "item-menu" },
                    [
                      _c(
                        "el-button",
                        {
                          class: {
                            "color-menu ":
                              _vm.getSelectedMenu === "observacoesImportantes"
                          },
                          attrs: {
                            type: "text",
                            index: "observacoesImportantes"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeRoute(
                                "observacoesImportantes",
                                "Observações importantes"
                              )
                            }
                          }
                        },
                        [_vm._v("Observações importantes")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.EXIBIR_DUVIDAS_FREQUENTES
                ? _c(
                    "div",
                    { staticClass: "item-menu" },
                    [
                      _c(
                        "el-button",
                        {
                          class: {
                            "color-menu ":
                              _vm.getSelectedMenu === "duvidasFrequentes"
                          },
                          attrs: { type: "text", index: "duvidasFrequentes" },
                          on: {
                            click: function($event) {
                              return _vm.changeRoute(
                                "duvidasFrequentes",
                                "Dúvidas frequentes"
                              )
                            }
                          }
                        },
                        [_vm._v("Dúvidas Frequentes")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "item-menu" },
                [
                  !_vm.isIcmBio
                    ? _c(
                        "el-button",
                        {
                          class: {
                            "color-menu ":
                              _vm.getSelectedMenu === "documentosCadastro"
                          },
                          attrs: { type: "text", index: "documentosCadastro" },
                          on: {
                            click: function($event) {
                              _vm.changeRoute(
                                "documentosCadastro",
                                "Documentos necessários (cadastro)"
                              )
                            }
                          }
                        },
                        [_vm._v("Documentos necessários (cadastros)")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.EXIBIR_CREDENCIADOS
                ? _c(
                    "div",
                    { staticClass: "item-menu" },
                    [
                      _c(
                        "el-button",
                        {
                          class: {
                            "color-menu ":
                              _vm.getSelectedMenu === "credenciadosListagem"
                          },
                          attrs: {
                            type: "text",
                            index: "credenciadosListagem"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeRoute(
                                "credenciadosListagem",
                                "Credenciados"
                              )
                            }
                          }
                        },
                        [_vm._v("Credenciados")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.EXIBIR_MODELOS_DOCS
                ? _c(
                    "div",
                    { staticClass: "item-menu" },
                    [
                      _c(
                        "el-button",
                        {
                          class: {
                            "color-menu ":
                              _vm.getSelectedMenu === "modelosDocumentos"
                          },
                          attrs: { type: "text", index: "modelosDocumentos" },
                          on: {
                            click: function($event) {
                              return _vm.changeRoute(
                                "modelosDocumentos",
                                "Modelos de documentos"
                              )
                            }
                          }
                        },
                        [_vm._v("Modelos de documentos")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _c("el-col", { attrs: { lg: 16, md: 16 } }, [
            _vm.dadosCarregados
              ? _c("div", { staticClass: "main" }, [_c("router-view")], 1)
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ff80a54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ff80a54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/Informacao.vue
// module id = null
// module chunks = 